module.exports = __webpack_public_path__ + "static/media/cargo.2f846939.png";